<template>
  <sidebar @close="close">
  
  <template v-slot:head>
    <div class="field" align="center">
          <figure class="avatar">
            <img :src="qrImg" />
          </figure>
    </div>
    <h2 class="title is-4" align="center"> Avanpost Authenticator </h2>
    <hr>
  </template>

  <template v-slot:body>     
      <div class="container has-text-centered">
        <div v-if="bindingStatusBool" class="select">
                  <select v-model="selectedBinding">
                    <option 
                      v-for="(n, key) in bindings" 
                      :key="key" 
                      :value="n"
                    >  {{ $t('auth_factors.authenticator_binding') }} {{ n.Time }} </option>
                  </select>
        </div>

        <div v-if="bindingStatusBool && bindingList.length > 0">
                {{ $t('auth_factors.authenticator_device') }} {{ selectedBinding.DeviceName }}
        </div> 

        <br>
      
        <div v-if="bindingStatusBool && bindingList.length > 0" class="button is-link is-fullwidth" @click="deactivate()">
            <span> {{ $t('auth_factors.authenticator_delete') }} </span>
        </div>
      
        <div v-else class="field" align="center">
          <div class="button is-link is-fullwidth" @click="newQR()">
            <span> {{ $t('auth_factors.authenticator_generate_new') }} </span>
          </div>   
          <hr>
          <span> {{ $t('auth_factors.authenticator_scan') }} </span>
        </div> 
      </div>
  </template>

  <template v-slot:foot>
      <div v-if="bindingStatusBool && additionalEnable" class="button is-link is-fullwidth" @click="additionalQR()">
        <span> {{ $t('auth_factors.authenticator_additional') }}  </span>
      </div>
      <br>
      <div v-if="additional && additionalEnable" class="field" align="center"> <span> {{ $t('auth_factors.authenticator_scan') }} </span> </div>
  </template>

  </sidebar>    
</template>

<script>
import Sidebar from "@/components/Sidebar"
import axios from "axios";
export default {
  name: "MobileAuthenticatorDetails",
  components: {
    Sidebar
  },
 
  data() {
    return {
        qrImg: require("@/assets/mobile.png"),
        error: "",
        bindingStatusBool: false,
        bindingPhone: null,
        bindings: {},
        bindingList: [],
        selectedBinding: {},
        additional: false,
        additionalEnable: false
    };
  },
  created() {
    this.fetchBinding()
    this.checkAdditionAvailable()
  },
  mounted() {},
  methods: {
    fetchQR() {
      axios.get("/personal/api/v1/mobile-2fa/qr/image", {responseType: 'arraybuffer'}).then(
        r => {
          this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
        }, 
        err => {
          console.log(err);
        }
      )
    },
    checkAdditionAvailable() {
        axios.get('/personal/api/v1/mobile-2fa/qr/additional/check-available', {responseType: 'json'}).then(
          r => {
            if (r.data.Enable) {
              this.additionalEnable = true
            }
          }
        )
    },
    fetchBinding() {
        axios.get('/personal/api/v1/mobile-2fa/binding/current', {responseType: 'json'}).then(
          r => {
            this.bindings = {}
            if (r.data.length > 0) {
                this.bindingList = r.data
                for (let i = 0; i < r.data.length; i++) {
                  let dt = new Date(r.data[i].CreatedAt) ;
                  r.data[i].Time = dt.toLocaleString('en-US',  {dateStyle: 'medium',timeStyle: 'medium',hour12: false}) ;
                  this.bindings[(i+1)] = r.data[i]
                }
                this.selectedBinding = this.bindingList[0]
                this.bindingStatusBool = true                
            } else {
                this.fetchQR()
              }
          })
          .catch(error => {
                  if (error.response.status == 404) {
                    this.fetchQR()
                  }
          }
        )
    },
    deactivate() {
      const path = '/personal/api/v1/mobile-2fa/binding/' + this.selectedBinding.Id + '/deactivate'
      axios.post(path, {}, {responseType: 'text'}).then(
        r => {
          if (r.status == 200) {
            this.bindingStatusBool = false
            this.bindingPhone = null
          }
          this.fetchBinding()
        }
      )
    },
    additionalQR() {
        axios.get('/personal/api/v1/mobile-2fa/qr/additional', {responseType: 'arraybuffer'}).then(
          r => {
            this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
            this.additional = true
          }, 
          err => {
            console.log(err);
          }
        )
    },
    newQR() {
        axios.get('/personal/api/v1/mobile-2fa/qr/new', {responseType: 'arraybuffer'}).then(
          r => {
            this.qrImg = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
          }, 
          err => {
            console.log(err);
          }
        )
    },
    close() {
      this.error = "";
      this.$emit("close");
    }
  }
};
</script>
